// extracted by mini-css-extract-plugin
module.exports = {"autoComplete":"TT","error":"UT","disabled":"VT"};